import { useCallback } from "react";
import { Table, Text, Switch } from "@radix-ui/themes";
import { CustomField } from "@/v2/entities/custom-field/CustomField.model";

interface CustomFieldItemProps {
  customField: CustomField;
  onToggle: (externalId: string, isActive: boolean) => Promise<void>;
}

export function CustomFieldItem({
  customField,
  onToggle,
}: CustomFieldItemProps) {
  const handleToggleActive = useCallback(
    async (isActive: boolean) => {
      await onToggle(customField.externalId, isActive);
    },
    [customField.externalId, onToggle]
  );

  return (
    <Table.Row>
      <Table.Cell>
        <Text size="2" weight="medium">
          {customField.key}
        </Text>
      </Table.Cell>
      <Table.Cell>
        <Text size="1" color="gray" style={{ fontFamily: "monospace" }}>
          {customField.externalId}
        </Text>
      </Table.Cell>
      <Table.Cell>
        <Switch
          checked={customField.isActive}
          onCheckedChange={handleToggleActive}
          highContrast
        />
      </Table.Cell>
    </Table.Row>
  );
}
